import { Font, StyleSheet, Text, View } from "@react-pdf/renderer";
import toRibuan from "../../utils/toRibuan";

Font.register({
    family: "Open-Sans",
    src: "https://fonts.gstatic.com/s/opensans/v29/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf",
});

interface IPrintStrukA4ServiceProps {
    serviceCustom?: number;
    serviceCustomPersen?: number | null;
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
        fontFamily: "Open-Sans",
        borderLeftColor: "#fff",
        borderLeftWidth: 1,
        borderRightColor: "#000",
        borderRightWidth: 1,
        fontSize: 11,
    },
    description: {
        width: "60%",
        textAlign: "right",
        borderRightColor: "#000",
        borderRightWidth: 1,
        paddingHorizontal: 8,
        height: 18,
    },
    subtotalText: {
        width: "20%",
        textAlign: "right",
        borderBottomColor: "#000",
        borderBottomWidth: 1,
        borderRightColor: "#000",
        borderRightWidth: 1,
        paddingHorizontal: 8,
        height: 18,
    },
    subtotal: {
        width: "20%",
        textAlign: "right",
        borderBottomColor: "#000",
        borderBottomWidth: 1,
        paddingHorizontal: 8,
        height: 18,
    },
});

const PrintStrukA4Service = ({ serviceCustom, serviceCustomPersen }: IPrintStrukA4ServiceProps) => {
    return (
        <View style={styles.row}>
            <Text style={styles.description}> </Text>
            <Text style={styles.subtotalText}>
                {serviceCustomPersen ? `Service (${serviceCustomPersen}%)` : `Pajak`}
            </Text>
            <Text style={styles.subtotal}>{toRibuan(Number(serviceCustom))}</Text>
        </View>
    );
};

export default PrintStrukA4Service;
